export enum TrmNetworksChainId {
  ethereum = 1,
}
